import { render, staticRenderFns } from "./share_heatmap.vue?vue&type=template&id=bb307a74&lang=pug&"
import script from "./share_heatmap.vue?vue&type=script&lang=js&"
export * from "./share_heatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports